import React, { useEffect, useMemo, useReducer, useState } from 'react'
import { Layout, Typography, Spin } from 'antd'
import { observer } from 'mobx-react'

// import MobileHeader from '../../../components/Partner/MobileHeader/MobileHeader'
import Profile from '../../../components/Partner/Profile/Profile'
import './MainStyle.css'
import Offer from '../../../components/Partner/Offer/Offer'
import Success from '../../../components/Partner/Success/Success'
import PolicyScreen from '../PolicyScreen/PolicyScreen'
import { useStores } from '../../../Store/Store'
import { useDataApi } from '../../../api/useDataApi'
import { AppConfig, partnerStatusCodes, innDetailsStatusCodes, selfEmployed, individual } from '../../../AppConfig'
import { getHeaders } from '../../../api/react-query/api'
import { useLocation } from 'react-router-dom'
import ProfileFormScreen from '../FormScreen/ProfileFormScreen'
import OfferSimple from '../../../components/Partner/Offer/OfferSimple'
import ProfileEditCardScreen from './ProfileEditCardScreen'
import PhotoDoc from '../../../components/Partner/PhotoDoc/PhotoDoc'
import { isFlowV2, simpleReducer } from '../../../helper'
import FormLmkScreen from '../FormScreen/FormLmkScreen'
import ProfileSelfEmployed from '../../../components/Partner/Profile/ProfileSelfEmployed'
import PolicyAgreement from '../../../components/Partner/PolicyAgreement/PolicyAgreement'
import { partnerRoles4MultiOffer } from '../../../Constants'
import FormFireBriefingScreen from '../FormScreen/FormFireBriefingScreen'
import FormEmploymentTypeScreen from '../FormScreen/FormEmploymentTypeScreen'
import BankAccept from '../../../components/Partner/BankAccept/BankAccept'
import MainScreenV2 from './MainScreenV2'
import PolicyScreenV2 from '../PolicyScreen/PolicyScreenV2'
import CheckingData from '../../../components/Partner/CheckingData'
import TaxServiceStep, { taxServiceSteps } from '../../../components/Partner/V2/TaxServiceStep/TaxServiceStep'

const { Content } = Layout
const { Title } = Typography
// const { Step } = Steps

const translates = {
  driverMainScreen: {
    title: 'Заполнение анкеты'
  }
}

const getScreen = profile => {
  if (profile?.statusCode === partnerStatusCodes.loginIssued && profile?.payoutSuspended) return AppConfig.partnerSteps.stepSuccess
  if (profile?.statusCode === partnerStatusCodes.loginIssued && profile?.offerExpires) return AppConfig.partnerSteps.stepOffer
  if (profile?.statusCode === partnerStatusCodes.loginIssued &&
    partnerRoles4MultiOffer.includes(profile?.personalData?.roleCode) &&
    (!profile?.cyberSecurityPolicy?.isValid || !profile?.assemblyAndDeliveryPolicy?.isValid)
  ) {
    return AppConfig.partnerSteps.stepOffer
  }
  if ([partnerStatusCodes.profileFilled,
    partnerStatusCodes.verification,
    partnerStatusCodes.selfFeeCheck,
    partnerStatusCodes.verified,
    partnerStatusCodes.loginIssued
  ].includes(profile?.statusCode) &&
    profile?.lmkDetails?.hasMedicalBook &&
    !profile?.lmkDetails?.agreementAccepted) {
    return AppConfig.partnerSteps.stepOffer
  }

  if ((profile?.statusCode === partnerStatusCodes.loginIssued || profile?.statusCode === partnerStatusCodes.blocked) &&
    !profile?.offerExpires && !profile?.renewAllowed
  ) return AppConfig.partnerSteps.stepSuccess

  if ([partnerStatusCodes.verification, partnerStatusCodes.selfFeeCheck, partnerStatusCodes.verified].includes(profile?.statusCode)) {
    if (profile?.smz?.statusCode === AppConfig.smzStatusCodes.fnsNotRegistered) {
      return AppConfig.partnerSteps.lastStepSelfEmployed
    }
    if (profile?.smz?.statusCode === AppConfig.smzStatusCodes.bindingConfirmation) {
      return AppConfig.partnerSteps.lastStepPartner
    }
    if (profile?.smz?.statusCode === AppConfig.smzStatusCodes.waitingPartnerConsent) {
      return AppConfig.partnerSteps.waitingPartnerConsent
    }
    if (profile?.smz?.statusCode === AppConfig.smzStatusCodes.statusConfirmation) {
      return AppConfig.partnerSteps.statusConfirmation
    }
  }

  if (profile?.statusCode === partnerStatusCodes.correction &&
    profile?.innDetails?.status === innDetailsStatusCodes.declined &&
    profile?.personalData?.legalForm === selfEmployed &&
    profile?.smz?.statusCode === AppConfig.smzStatusCodes.bindingConfirmed
  ) {
    return AppConfig.partnerSteps.changeFIOatFNS
  }

  if ([partnerStatusCodes.verification, partnerStatusCodes.selfFeeCheck, partnerStatusCodes.verified].includes(profile?.statusCode) &&
        (
          profile?.smz?.statusCode === AppConfig.smzStatusCodes.bindingConfirmed ||
          ([
            AppConfig.smzStatusCodes.error,
            AppConfig.smzStatusCodes.statusConfirmation
          ].includes(profile?.smz?.statusCode) && profile?.innPhoto?.fileId) ||
          (profile?.personalData?.legalForm === individual && profile?.innPhoto?.fileId) || (
            partnerStatusCodes.verification === profile?.statusCode &&
            profile?.personalData?.legalForm === selfEmployed &&
            profile.partnerFlow === AppConfig.partnerFlow.v2
          )
        )) {
    return AppConfig.partnerSteps.processing
  }

  switch (profile?.statusCode) {
    case partnerStatusCodes.new:
    case partnerStatusCodes.draft:
    case partnerStatusCodes.free:
    case partnerStatusCodes.correction: return AppConfig.partnerSteps.stepProfile
    case partnerStatusCodes.profileFilled: return AppConfig.partnerSteps.stepOffer
    case partnerStatusCodes.verification:
    case partnerStatusCodes.selfFeeCheck:
    case partnerStatusCodes.verified:
    case partnerStatusCodes.loginIssued:
    case partnerStatusCodes.loginNotFound:
    case partnerStatusCodes.rejected: return AppConfig.partnerSteps.stepSuccess
    default: return AppConfig.partnerSteps.stepProfile
  }
}

export const PROFILE_CARD_STATE_INIT = {
  form: null,
  storeData: null
}

export const PROFILE_EDITINFO_STATE_INIT = {
  form: null,
  sessionChangedFields: []
}

export const PROFILE_LMK_STATE_INIT = {
  form: null
}

export const PROFILE_EMPLOYMENT_TYPE_STATE_INIT = {
  form: null
}

const MainScreen = () => {
  const store = useStores()
  const location = useLocation()
  const currentScreen = getScreen(store?.partnerProfile?.profile)
  const [current, setCurrent] = useState(currentScreen)
  const [profileCardState, setProfileCardState] = useReducer(simpleReducer, PROFILE_CARD_STATE_INIT)
  const [profileEditInfoState, setProfileEditInfoState] = useReducer(simpleReducer, PROFILE_EDITINFO_STATE_INIT)
  const [profileLmkState, setProfileLmkState] = useReducer(simpleReducer, PROFILE_LMK_STATE_INIT)
  const [profileEmploymentTypeState, setProfileEmploymentTypeState] = useReducer(simpleReducer, PROFILE_EMPLOYMENT_TYPE_STATE_INIT)

  const [{ data, isLoading }] = useDataApi({
    initialUrl: store?.partnerProfile?.profile?.personalData?.mobilePhone ? '' : 'partner/profile',
    initialParams: {
      method: 'GET',
      headers: getHeaders()
    }
  })
  useEffect(() => {
    if (data?.isSuccess && !store?.partnerProfile?.profile?.personalData?.mobilePhone) {
      store?.partnerProfile?.setPartnerProfile(data?.partner)
      const currentScreen = getScreen(data?.partner?.profile)
      setCurrent(currentScreen)
    }
  }, [data, store])

  /**
   * Если пользователь обновил страницу ожидаем профиль с сервера "data"
   * Если пользователь перешел с экрана логина ищем профиль в "store?.partnerProfile"
   */
  const profile = store?.partnerProfile?.profile?.personalData ? store?.partnerProfile?.profile : data?.partner?.profile

  const isContentPartner = useMemo(() => {
    return profile?.personalData?.roleCode === AppConfig.partnerRoles.szContent
  }, [profile])

  const isResearcherPartner = useMemo(() => {
    return profile?.personalData?.roleCode === AppConfig.partnerRoles.researcher
  }, [profile])

  const isOperatorPartner = useMemo(() => {
    return profile?.personalData?.roleCode === AppConfig.partnerRoles.szOperator
  }, [profile])

  const isMentorPartner = useMemo(() => {
    return profile?.personalData?.roleCode === AppConfig.partnerRoles.szMentor
  }, [profile])

  const handleUpdateScreen = (profile) => setCurrent(getScreen(profile))

  const steps = {
    [AppConfig.partnerSteps.stepProfile]: {
      title: '',
      content: <Profile onSuccess={setCurrent} />,
      contentRoleContent: <ProfileSelfEmployed onSuccess={setCurrent} />
    },
    [AppConfig.partnerSteps.stepOffer]: {
      title: '',
      content: <Offer onSuccess={setCurrent} />
    },
    [AppConfig.partnerSteps.stepSuccess]: {
      title: '',
      content: <Success />
    },
    [AppConfig.partnerSteps.stepChecking]: {
      title: '',
      content: <CheckingData />
    },
    [AppConfig.partnerSteps.lastStepSelfEmployed]: {
      title: '',
      content: <TaxServiceStep step={taxServiceSteps.lastStepSelfEmployed} profile={profile} handleUpdateScreen={handleUpdateScreen} />
    },
    [AppConfig.partnerSteps.lastStepPartner]: {
      title: '',
      content: <TaxServiceStep step={taxServiceSteps.lastStepPartner} profile={profile} handleUpdateScreen={handleUpdateScreen} />
    },
    [AppConfig.partnerSteps.waitingPartnerConsent]: {
      title: '',
      content: <TaxServiceStep step={taxServiceSteps.waitingPartnerConsent} profile={profile} handleUpdateScreen={handleUpdateScreen} />
    },
    [AppConfig.partnerSteps.statusConfirmation]: {
      title: '',
      content: <TaxServiceStep step={taxServiceSteps.statusConfirmation} profile={profile} handleUpdateScreen={handleUpdateScreen} />
    },
    [AppConfig.partnerSteps.changeFIOatFNS]: {
      title: '',
      content: <TaxServiceStep step={taxServiceSteps.changeFIOatFNS} profile={profile} handleUpdateScreen={handleUpdateScreen} />
    },
    [AppConfig.partnerSteps.processing]: {
      title: '',
      content: <TaxServiceStep step={taxServiceSteps.processing} profile={profile} />
    }
  }

  const isNeedPolicyAgreement = !profile?.personalDataPolicy?.isValid || !profile?.electronicSignaturePolicy?.isValid
  const isNeedPolicyAgreementV2 = isFlowV2(profile) && (
    isNeedPolicyAgreement ||
    !profile?.cyberSecurityPolicy?.isValid ||
    !profile?.assemblyAndDeliveryPolicy?.isValid ||
    (profile?.statusCode === partnerStatusCodes.loginIssued && profile?.offerExpires)
  )
  const isNeedFlowV1Links =
    location.search.includes(`?action=${AppConfig.formScreenActions.editInfo}`) ||
    location.search.includes(`?action=${AppConfig.formScreenActions.editCard}`) ||
    location.search.includes(`?action=${AppConfig.formScreenActions.editLmk}`) ||
    location.search.includes(`?action=${AppConfig.formScreenActions.editFireBriefing}`) ||
    location.search.includes(`?action=${AppConfig.formScreenActions.editEmploymentType}`) ||
    location.search.includes(`?action=${AppConfig.formScreenActions.photoDoc}`) ||
    location.search.includes(`?action=${AppConfig.formScreenActions.offer}`) ||
    location.search.includes(`?action=${AppConfig.formScreenActions.offerType}`)
  const isExternalBlocked = profile?.statusCode === partnerStatusCodes.externalBlocked

  if (isFlowV2(profile) && (
    !(isNeedPolicyAgreement || isNeedPolicyAgreementV2 || isNeedFlowV1Links) ||
    isExternalBlocked)
  ) {
    return <MainScreenV2 isLoading={isLoading} profile={profile} />
  }

  if (profile?.tinkoffData?.bankConfirmRequired) {
    return <BankAccept profile={profile} setStep={setCurrent} />
  }
  if (location.search === `?action=${AppConfig.formScreenActions.editInfo}`) {
    return <ProfileFormScreen extState={profileEditInfoState} setExtState={setProfileEditInfoState} />
  }
  if (location.search === `?action=${AppConfig.formScreenActions.editCard}`) {
    return <ProfileEditCardScreen extState={profileCardState} setExtState={setProfileCardState} />
  }
  if (location.search === `?action=${AppConfig.formScreenActions.editLmk}`) {
    return <FormLmkScreen extState={profileLmkState} setExtState={setProfileLmkState} />
  }
  if (location.search === `?action=${AppConfig.formScreenActions.editFireBriefing}`) {
    return <FormFireBriefingScreen />
  }
  if (location.search === `?action=${AppConfig.formScreenActions.editEmploymentType}`) {
    return <FormEmploymentTypeScreen extState={profileEmploymentTypeState} setExtState={setProfileEmploymentTypeState} />
  }
  if (location.search.includes(`?action=${AppConfig.formScreenActions.offerType}`)) {
    return <PolicyAgreement profileLmkState={profileLmkState} profileEditInfoState={profileEditInfoState} />
  }
  if (location.search.includes(`?action=${AppConfig.formScreenActions.offer}`)) {
    return <OfferSimple />
  }
  if (location.search.includes(`?action=${AppConfig.formScreenActions.photoDoc}`)) {
    return <PhotoDoc />
  }

  const isAdditionalClass = [
    partnerStatusCodes.verification,
    partnerStatusCodes.selfFeeCheck
  ].includes(profile?.statusCode)

  return (
    <Layout className={`ProfileWrapper ${isAdditionalClass && 'checking'} ${(isFlowV2(profile) || isNeedPolicyAgreement) && 'V2-flow'} ${profile?.statusCode}`}>
      {/* {!isNeedPolicyAgreementV2 && <MobileHeader />} */}
      <Spin spinning={isLoading} size='large'>
        {isNeedPolicyAgreement || isNeedPolicyAgreementV2
          ? (isNeedPolicyAgreementV2 ? <PolicyScreenV2 /> : <PolicyScreen />)
          : (
            <Content style={{ height: '100%' }}>
              {![
                AppConfig.partnerSteps.stepSuccess,
                AppConfig.partnerSteps.changeFIOatFNS,
                AppConfig.partnerSteps.statusConfirmation,
                AppConfig.partnerSteps.waitingPartnerConsent,
                AppConfig.partnerSteps.lastStepPartner,
                AppConfig.partnerSteps.lastStepSelfEmployed,
                AppConfig.partnerSteps.processing
              ].includes(current) && <Title level={4}>{translates.driverMainScreen.title}</Title>}
              {/* <Steps current={current} className={profile?.payoutSuspended && 'danger-step'}> */}
              {/*  {Object.keys(steps).map(item => ( */}
              {/*    <Step key={steps[item].title} title={steps[item].title} /> */}
              {/*  ))} */}
              {/* </Steps> */}
              <div className='steps-content'>
                {
                  (isContentPartner || isResearcherPartner || isOperatorPartner || isMentorPartner) && current === AppConfig.partnerSteps.stepProfile
                    ? steps[current].contentRoleContent
                    : steps[current].content
                }
              </div>
            </Content>
          )}
      </Spin>
    </Layout>
  )
}
export default observer(MainScreen)
